<template>
  <div
    class="subscribe-popup-content"
    :class="{ 'subscribe-popup-content--20504': treatment }"
  >
    <h2 class="subscribe-popup-content__headline">
      Unlock over
      <span class="subscribe-popup-content__headline-accent">{{
        ContentStats.guides
      }}</span>
      summaries
    </h2>

    <BookCoverStack v-if="!treatment" :book="book" />

    <p class="subscribe-popup-content__plan-line">
      Start your {{ planNickname }} trial to access the full library
    </p>
  </div>
</template>

<script setup lang="ts">
import type { InterestBook } from '@/helpers/billingSourceBook'

import BookCoverStack from '@/app/components/book/BookCoverStack.vue'
import { ContentStats } from '@/helpers/contentStats'

defineProps<{
  book: InterestBook
  planNickname: string
  treatment?: boolean
}>()
</script>

<style lang="scss" scoped>
.subscribe-popup-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
  padding-top: 16px;

  &__headline {
    margin: 0;
    color: $c-black-2;
    font-size: 22px;
    font-weight: 500;
    line-height: 28px;
    letter-spacing: -0.02em;
    text-align: center;
  }

  &__headline-accent {
    color: #5aa96b;
  }

  &__plan-line {
    margin: 0;
    color: $c-black-15;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
  }

  &--20504 {
    gap: 6px;
    margin-bottom: 20px;

    .subscribe-popup-content__headline {
      font-size: 24px;
      line-height: 1.2;
    }

    .subscribe-popup-content__headline-accent {
      color: inherit;
    }

    .subscribe-popup-content__plan-line {
      color: $c-black-3;
      line-height: 21px;
      letter-spacing: -0.28px;
    }
  }
}

.night-mode {
  .subscribe-popup-content {
    &__headline {
      color: $c-black-11;
    }

    &__plan-line {
      color: $c-black-11;
    }
  }
}
</style>
